import notifications, {Response} from 'notifications';
import * as ImportUtil from 'util/ImportUtil';
import * as net from 'util/Net';
import {JSONValue} from 'util/Types';

export function createAnalysisFromRun(
  runId: string,
  fileVariableBindings: Array<{variableId: string; variableValue: JSONValue}>
): Promise<{status_url: string}> {
  return net.postJSONPromise({
    url: `/1/api/automation-pipelines/${runId}:create-analysis-from-run`,
    data: {
      fileVariableBindings,
    },
  });
}

export function bulkCreatePipelineFiles(
  runId: string,
  s3Locations: Array<string>
): Promise<{fileIds: Array<string>}> {
  return net.postJSONPromise({
    url: `/1/api/automation-pipelines/${runId}:bulk-create-pipeline-files`,
    data: {
      s3Locations,
    },
  });
}

export function createFilesFromUploads(
  runId: string,
  files: Array<File>,
  {onFilesUploaded}: {onFilesUploaded: (s3Locations: Array<string>) => void}
): JQueryPromise<void> {
  return ImportUtil.bulkUpload(files)
    .then((...s3Locations: Array<string>) => {
      onFilesUploaded(s3Locations);
    })
    .fail((e: Response) => {
      notifications.notifyError(e);
    });
}
